<template>
  <div>
    <validation-observer ref="form" tag="div">
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.startCase($t('manufactures.singular'))"
          class="col-md-6"
          vid="manufacture_id"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.startCase($t('manufactures.singular')) + '*'"
            :state="errors[0] ? false : validated ? true : null"
            class="row mb-3"
            label-cols-md="12"
        >
          <multiselect-ajax
              :key="`${_uid}-manufactures`"
              v-model.number="model.manufacture_id"
              :custom-label="manufactureLabel"
              :params="{ type: 'feed' }"
              url="/v1/manufactures"
              name="manufacture_id"
              @update:selected="onManufactureUpdated"
          >
          </multiselect-ajax>
        </b-form-group>
      </validation-provider>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.startCase($t('manufactures.name'))"
          class="col-md-6"
          rules="required"
          vid="name"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.startCase($t('manufactures.name')) + '*'"
            :state="errors[0] ? false : validated ? true : null"
            class="row mb-3"
            label-cols-md="12"
        >
          <b-form-input
              id="name"
              v-model="model.name"
              :state="errors[0] ? false : validated ? true : null"
              name="name"
              type="text"
          ></b-form-input>
        </b-form-group>
      </validation-provider>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.startCase($t('manufactures.is_active'))"
          class="col-md-6"
          rules="required"
          vid="name"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.startCase($t('manufactures.status')) + '*'"
            :state="errors[0] ? false : validated ? true : null"
            class="row mb-3"
            label-cols-md="12"
        >
          <b-form-checkbox
              id="checkbox-1"
              v-model="model.is_active"
              name="checkbox-is-active"
          >
            {{ lodash.upperFirst($t('manufactures.is_active')) }}
          </b-form-checkbox>

        </b-form-group>
      </validation-provider>
    </validation-observer>
  </div>
</template>

<script>
import FormModel from "./model";

export default {
  extends: FormModel,
  components: {},
  data() {
    return {
      model: {
        ...this.value,
      },
      typeOptions: [
        {text: this.lodash.upperFirst(this.$t("manufactures.types.feed")), value: "feed"},
        {text: this.lodash.upperFirst(this.$t("manufactures.types.seed")), value: "seed"},
      ],
      segmentedButtons: [],
    };
  },
  methods: {
    manufactureLabel(manufacture) {
      const { name, short_name } = manufacture
      if (short_name) {
        return `${name} (${short_name})`
      }
      return name
    },
  }
};
</script>
<style lang="scss" scoped>
::v-deep {
  .custom-checkbox .custom-control-label::before {
    border-radius: 0.25rem;
  }

  .col-form-label {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #6c7589;
  }
}
</style>

<style lang="scss" scoped>
.section-title {
  font-weight: 800;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.05em;
  color: #0084f3;
}

::v-deep {
  table {
    thead {
      background: #f9fafb !important;
    }
  }

  .vs__selected-options input {
    padding: 4px 16px;
  }
}

.card-form {
  max-width: 720px;
}
</style>

<style lang="scss">
.vs__dropdown-menu {
  z-index: 9999 !important;
}

.button-add-bank {
  transition: background .2s ease-in;
  border-radius: 0;

  &:hover {
    background: #EEF3F7;
  }
}
</style>
